import * as React from 'react'
import * as SideMenu from 'components/side-menu'
import {
  HouseSimple,
  DoorOpen,
  CreditCard,
  Globe,
  ApproximateEquals,
  Star,
} from '@phosphor-icons/react'
import { HealthAuditNavIcon } from 'components/side-nav/items/health-audit-link'
import { store } from 'store/index'
import { Warning } from 'src/design-system/icons/Warning'
import { useIsActivePath } from '../../../utils/use-is-active'
import { IntegrationsAccordion } from './integrations-accordion'
import { CheckinsAccordion } from './checkins-accordion'

type OrgSectionProps = {
  showSsoLink: boolean
  showHrisLink: boolean
}

export const OrgSection = (props: OrgSectionProps) => {
  const { showSsoLink, showHrisLink } = props

  const { isActive } = useIsActivePath()
  const orgSlug = store.currentUser?.org?.slug
  const orgName = store.currentUser?.org?.name
  const positionMapping = store.currentUser?.org?.enablePositionMapping
  const hasIssues = store.currentUser?.org?.hasIssues
  const enableHealthAudit = store.currentUser?.org?.enableHealthAudit
  const enableCustomRatingScales =
    store.currentUser?.org?.enableCustomRatingScales
  const isAdmin = store.currentUser?.isAdmin

  const sectionItems = [
    {
      title: (
        <>
          General
          {hasIssues && enableHealthAudit && isAdmin && <Warning />}
        </>
      ),
      href: `/orgs/${orgSlug}/edit`,
      icon: HouseSimple,
    },
    ...(enableCustomRatingScales
      ? [
          {
            title: 'Custom Rating Scales',
            href: `/orgs/${orgSlug}/custom-rating-scales`,
            icon: Star,
          },
        ]
      : []),
    ...(isAdmin && enableHealthAudit
      ? [
          {
            title: 'Health Audit',
            href: `/orgs/${orgSlug}/health-audit-settings`,
            icon: HealthAuditNavIcon,
          },
        ]
      : []),
    {
      title: 'User Permissions',
      href: `/orgs/${orgSlug}/preferences`,
      icon: DoorOpen,
    },
    {
      title: 'Billing',
      href: `/orgs/${orgSlug}/billing`,
      icon: CreditCard,
    },
    {
      title: (
        <>
          Organisation Home
          {hasIssues && enableHealthAudit && isAdmin && <Warning />}
        </>
      ),
      href: `/orgs/${orgSlug}/organisation-home`,
      icon: Globe,
    },
    ...(positionMapping
      ? [
          {
            title: 'Position Aliases',
            href: `/orgs/${orgSlug}/position-aliases`,
            icon: ApproximateEquals,
          },
        ]
      : []),
  ]

  const renderItem = (item: (typeof sectionItems)[number]) => (
    <SideMenu.LinkItem
      key={item.href}
      href={item.href}
      active={isActive(item.href)}
      icon={item.icon}
    >
      {item.title}
    </SideMenu.LinkItem>
  )

  return (
    <SideMenu.MenuSection>
      <SideMenu.MenuSectionTitle>{orgName}</SideMenu.MenuSectionTitle>
      {renderItem(sectionItems[0])}
      <CheckinsAccordion />
      {sectionItems.slice(1).map(renderItem)}
      <IntegrationsAccordion
        showSsoLink={showSsoLink}
        showHrisLink={showHrisLink}
      />
    </SideMenu.MenuSection>
  )
}
